<div mat-dialog-title>
  <h2>
    {{'payment.payment' | translate}}
  </h2>
</div>
<mat-dialog-content class="pb-0">
  <div class="checkout-dialog">
    <div class="modal-body checkout-dialog-body" id="formModalBody" *ngIf="PaymentObj">
      <app-payment-card-form [service]="data.service" [paymentObj]="PaymentObj"
        [files]="data.files"></app-payment-card-form>
    </div>
  </div>
</mat-dialog-content>